<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @addNew='handleExport'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>日期:</label>
            <timeStampDatePicker  v-model='query.startTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.endTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem storeSelect">
            <label>业务类型:</label>
            <lk-select
              class="item"
              multiple
              v-model="query.bizTypeList">
              <lk-option v-for="option in typeList" :key="option.id" :value="option.id">
                {{option.name}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商编码:</label>
            <lk-input clearable v-model='query.supplierCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model="query.supplierStoreIdList" multiple></SupplierListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix" ></goodsSearchItem>
          </div>
           <div class="queryItem">
            <label>商品分类:</label>
            <div class="item">
              <TreeSelect v-model.trim="query.categoryIdList" :data="indicationTree" :props="{title: 'label', value: 'value', children: 'children'}"></TreeSelect>
            </div>
         </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.labelIdList' class="item" clearable multiple >
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false,getTotal)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap btn">
          <exportAsync class="mr" @on-click='handleExport' v-if="handlePermission('inboundReturnDecisionExport')"></exportAsync>
          <lk-button type="primary" class="mr" @click='refreshTime'>刷新今日报表</lk-button>
          <div v-if="deadline">数据截止至 {{deadline}}</div>
        </div>


        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">数量:</div>
            <div class="Report-total-item-value">{{total.numStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">件数:</div>
            <div class="Report-total-item-value">{{total.piecesStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">售价金额:</div>
            <div class="Report-total-item-value">{{total.saleAmountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税成本金额:</div>
            <div class="Report-total-item-value">{{total.costAmountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税成本金额:</div>
            <div class="Report-total-item-value">{{total.costAmountWithoutTaxStr}}</div>
          </div>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
// import goodsService from '@/services/goods';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import reportMixin from './reportMixin.js';
import exportAsync from '../../components/report/ExportAsync.vue';
// import goodsSelect from '../../components/report/GoodsSelect.vue';
import TreeSelect from '../../components/treeSelect/treeSelect.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

export default {
  name: 'inboundReturnDecisionList',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame,
    exportAsync,
    TreeSelect,
    SupplierListSelect,
  },
  data() {
    return {
      deadline: '',
      typeList: [{
        id: 1,
        name: '采购入库',
      }, {
        id: 2,
        name: '	销售退货',
      }, {
        id: 3,
        name: '库存溢出',
      }, {
        id: 4,
        name: '销售出库',
      }, {
        id: 5,
        name: '供应商退货',
      }, {
        id: 6,
        name: '库存报损',
      }, {
        id: 7,
        name: '库存损失',
      }, {
        id: 8,
        name: '库存召回',
      }, {
        id: 20,
        name: '拆零出库',
      }, {
        id: 21,
        name: '拆零入库',
      }],

      query: {
        storeIdList: [],
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        bizTypeList: [],
        supplierCode: '',
        supplierStoreIdList: [],
        nameMix: '',
        categoryIdList: null,
        labelIdList: [],
        isDtp: null,
      },
      total: {},
      columns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '日期',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '业务机构',
          key: 'inventoryVoStoreCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'inventoryVoStoreName',
          minWidth: 116,
        },
        {
          title: '业务类型',
          key: 'inventoryRecordReportBizType',
          minWidth: 116,
        },
        {
          title: '供应商编码',
          key: 'inventoryRecordReportSupplierCode',
          minWidth: 116,
        },
        {
          title: '供应商名称',
          key: 'inventoryRecordReportSupplierName',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'inventoryVoGoodsSerialCode',
          minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'inventoryVoGoodsApprovedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'inventoryVoSpec',
          minWidth: 116,
        },
        {
          title: '生产厂家',
          key: 'inventoryVoProducer',
          minWidth: 116,
        },
        {
          title: '产地',
          key: 'inventoryVoOrigin',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'inventoryVoMinPkgUnitName',
          minWidth: 116,
        },
        {
          title: '含税成本单价',
          key: 'costPriceStr',
          minWidth: 116,
        },
        {
          title: '最新售价',
          key: 'retailPriceStr',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'numStr',
          minWidth: 116,
        },
        {
          title: '件数',
          key: 'piecesStr',
          minWidth: 116,
        },
        {
          title: '批号',
          key: 'inventoryVoBatchCode',
          minWidth: 116,
        },
        {
          title: '生产日期',
          key: 'inventoryVoProdDate',
          minWidth: 116,
        },
        {
          title: '有效期至',
          key: 'inventoryVoExpiryDate',
          minWidth: 116,
        },
        {
          title: '售价金额',
          key: 'saleAmountStr',
          minWidth: 116,
        },
        {
          title: '含税成本金额',
          key: 'costAmountStr',
          minWidth: 116,
        },
        {
          title: '不含税成本金额',
          key: 'costAmountWithoutTaxStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      goodsLoading: false,
      goodsList: [],
    };
  },
  methods: {
    refreshTime() {
      this.$store.commit('setDisableLoading', true);
      reportService.inventoryRefresh()
        .then((res) => {
          const data = res.data;
          if (data.status == 200) {
            if (data.data.success) {
              this.getRefreshTime();
              this.handleSearch(true, this.getTotal);
            } else {
              this.$Message.error(data.data.message);
            }
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getRefreshTime() {
      this.$store.commit('setDisableLoading', true);
      reportService.getInventoryRefresh()
        .then((res) => {
          if (res.data.status == 200) {
            this.deadline = res.data.data.refreshTimeStr;
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleExport(info, func) {
      const params = utils.deepClone(this.params);
      if (!params.supplierStoreIdList) {
        delete params.supplierStoreIdList;
      }
      // if (this.params.startTime) {
      //   this.params.startTime = (new Date(this.params.startTime)).getTime();
      // }
      // if (this.params.endTime) {
      //   this.params.endTime = (new Date(this.params.endTime)).getTime();
      // }
      this.$store.commit('setDisableLoading', true);
      reportService.inboundReturnDecisionExport(utils.deletePageAndSize(params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getTotal() {
      // if (this.params.startTime) {
      //   this.params.startTime = (new Date(this.params.startTime)).getTime();
      // }
      // if (this.params.endTime) {
      //   this.params.endTime = (new Date(this.params.endTime)).getTime();
      // }

      reportService.inboundReturnDecisionTotal(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {

        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        goodsSerialCode: '',
        bizTypeList: [],
        goodsBaseIdList: [],
        storeIdList: [],
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.startTime) {
      //   this.params.startTime = (new Date(this.params.startTime)).getTime();
      // }
      // if (this.params.endTime) {
      //   this.params.endTime = (new Date(this.params.endTime)).getTime();
      // }

      reportService.inboundReturnDecision(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = result.createTime ? utils.formatTime(result.createTime, 'YYYY-MM-DD') : '';
            result.inventoryVoProdDate = result.inventoryVoProdDate ? utils.formatTime(result.inventoryVoProdDate, 'YYYY-MM-DD') : '';
            result.inventoryVoExpiryDate = result.inventoryVoExpiryDate ? utils.formatTime(result.inventoryVoExpiryDate, 'YYYY-MM-DD') : '';
            this.typeList.forEach((element) => {
              if (element.id == result.inventoryRecordReportBizType) {
                result.inventoryRecordReportBizType = element.name;
              }
            });

            this.tableData.push(result);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // fetchGoods(query) {
    //   if (query !== '') {
    //     const data = {
    //       nameMix: query,
    //       page: 1,
    //       size: 5,
    //     };
    //     this.goodsLoading = true;
    //     this.$store.commit('setDisableLoading', true);
    //     goodsService.listGoodsBases(data).then((res) => {
    //       if (res.data.status === 200 && res.data.data.list) {
    //         this.goodsList = res.data.data.list;
    //       } else {
    //         this.$Message.error(res.data.error);
    //       }
    //       this.goodsLoading = false;
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    //   } else {
    //     this.goodsList = [];
    //   }
    // },
  },
  mounted() {
    this.fetchListIndications();
    this.getLabel();
    this.handleSearch(true, this.getTotal);
    this.getRefreshTime();
  },
};
</script>
<style lang="less" scoped>
.btn{
  margin-bottom: 12px
}
</style>
